// routes/FrontendRoutes.js

import React from 'react';
import { Route } from 'react-router-dom';
import MainLayout from '../layouts/MainLayout';
import ChatComponent from '../components/Frontend/Chat/ChatComponent';

export const chatRoute = (
  <>
    <Route path="/ai_assistant" element={<MainLayout />}>
      <Route path=":session_Id?" index element={
        <ChatComponent></ChatComponent>
      } />
    </Route>
  </>
);